function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PointerSensor } from '@dnd-kit/core';

/**
 * An extended "PointerSensor" that prevent some
 * interactive html element(button, input, textarea, select, option...) from dragging
 */
export default class PointerSensorWithInteraction extends PointerSensor {}
_defineProperty(PointerSensorWithInteraction, "activators", [{
  eventName: 'onPointerDown',
  handler: _ref => {
    var event = _ref.nativeEvent;
    if (!event.isPrimary || event.button !== 0 || isInteractiveElement(event.target)) {
      return false;
    }
    return true;
  }
}]);
var INTERACTIVE_ELEMENTS = ['button', 'input', 'textarea', 'select', 'option'];
function isInteractiveElement(element) {
  if ((element === null || element === void 0 ? void 0 : element.tagName) != null && INTERACTIVE_ELEMENTS.includes(element.tagName.toLowerCase())) {
    return true;
  }
  return false;
}
//# sourceMappingURL=PointerSensorWithInteraction.js.map